/**
 * 下载文件
 * @param data
 * @param fileName
 */
import { getFlyNum } from "/@/api/sys/sys";
import { sysType } from "/@/types/task";
import { ELocalStorageKey } from "/@/types";
import pin2d8cf0 from "/@/assets/icons/pin-e23c39.svg";
import { ref, nextTick, unref } from "vue";
export function downloadFile(data: Blob, fileName: any) {
  const lable = document.createElement("a");
  lable.href = window.URL.createObjectURL(data);
  lable.download = fileName;
  lable.click();
  URL.revokeObjectURL(lable.href);
}
// 获取地图默认参数
export async function getMapDataApi() {
  const workspaceId: string =
    localStorage.getItem(ELocalStorageKey.WorkspaceId) || "";
  let mapFormState = {
    lng: 0,
    lat: 0,
    maps: 1,
    mapsxyz: [] as any,
  };
  const res = await getFlyNum({ sysName: sysType[2].key }, workspaceId);
  // console.log(93,res);
  const mapxyz = [
    {
      maps: 1, //cesium
      lng: 0,
      lat: 0,
      height: 0,
    },
    {
      maps: 2, //星图
      lng: 0,
      lat: 0,
      height: 0,
    },
    {
      maps: 3, //自有
      lng: 0,
      lat: 0,
      height: 0,
    },
    {
      maps: 4, //mapbox
      lng: 0,
      lat: 0,
      height: 0,
    },
  ];
  if (res.code == 0) {
    if (res?.data?.sys_value) {
      const sysValue = JSON.parse(res?.data?.sys_value);
      mapFormState.lng = sysValue?.lng ? parseFloat(sysValue?.lng) : 104.092518;
      mapFormState.lat = sysValue?.lat ? parseFloat(sysValue?.lat) : 30.654566;
      mapFormState.maps = sysValue?.maps ? sysValue?.maps : 1;
      mapFormState.mapsxyz = sysValue?.mapsxyz ? sysValue?.mapsxyz : mapxyz;
    } else {
      mapFormState.lng = 104.092518;
      mapFormState.lat = 30.654566;
      mapFormState.maps = 1;
      mapFormState.mapsxyz = mapxyz;
    }
  }
  return mapFormState;
}
// 地图图层、高程地址
export const mapUrlList = (window as any).ConfigManage?.mapUrlList || {
  // 星图的瓦片地址
  xin_imgUrl:
    "https://tiles1.geovisearth.com/base/v1/img/{z}/{x}/{y}?format=webp&tmsIds=w&token=b8930f0922848527e6d47b986094ca821134be9a34350d19d416eb6e3ad2cfce",
  //  星图的高程地址
  xin_treeain:
    "https://tiles1.geovisearth.com/base/v1/terrain?token=b8930f0922848527e6d47b986094ca821134be9a34350d19d416eb6e3ad2cfce",
  //  自有的瓦片地址
  // own_imgurl: "http://223.86.29.68:68/wapian/{z}/{x}/{y}/tile.png", // 广汉
  // own_imgurl: "http://125.70.13.132:8086/{z}/{x}/{y}/tile.png", // 科尔沁
  own_imgurl: "https://fly.cdjjhb.cn:1111/{z}/{x}/{y}/tile.png", // fly
  // own_imgurl: "http://221.179.250.5:8086/tile/{z}/{x}/{y}/tile.png", // 拉萨
  // 自有的高程地址
  // own_treeain: "http://223.86.29.68:1887/height/", // 广汉
  // own_treeain: "http://125.70.13.132:8086/height/", // 科尔沁
  own_treeain: "https://fly.cdjjhb.cn/height/", // fly
  // own_treeain: "http://221.179.250.5:8086/height/", // 拉萨
  // cesium的瓦片地址
  ces_imgurl1: "https://t0.tianditu.gov.cn/cia_w/wmts?tk=5af8222731253d990c26cf8e801f5482", // fly
  ces_imgurl2: "https://t0.tianditu.gov.cn/img_w/wmts?tk=5af8222731253d990c26cf8e801f5482", // fly
  // ces_imgurl1: "https://t0.tianditu.gov.cn/cia_w/wmts?tk=79f64855f887641ab0f40287acea1954", // 广汉
  // ces_imgurl2: "https://t0.tianditu.gov.cn/img_w/wmts?tk=79f64855f887641ab0f40287acea1954", // 广汉
  // ces_imgurl1:
  //   "https://t0.tianditu.gov.cn/cia_w/wmts?tk=8cc9644b4072777c570eb7572cebe04b", // 拉萨
  // ces_imgurl2:
  //   "https://t0.tianditu.gov.cn/img_w/wmts?tk=8cc9644b4072777c570eb7572cebe04b", // 拉萨
  ces_token: ["5af8222731253d990c26cf8e801f5482"], // cesium初始化使用天地图token    fly使用天地图token
  // ces_token: ["79f64855f887641ab0f40287acea1954"], // cesium初始化使用天地图token    广汉 使用天地图token
  // ces_token: ["8cc9644b4072777c570eb7572cebe04b"], // cesium初始化使用天地图token    拉萨
  // mapbox的瓦片地址(自定义样式)
  // mapbox_imgurl:
  //   "https://api.mapbox.com/styles/v1/35cd60rcdf/cm0n9bq4v001801pqbp9i7ei4/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiMzVjZDYwcmNkZiIsImEiOiJjbHczcndtdzkxMHluMmlscjRpZjRqOXl2In0.qp1uNmZpGLhouSpHvZNLng",
  // mapbox 瓦片地址（自带，标注是部分是英文）
  mapbox_imgurl:
    "https://api.mapbox.com/styles/v1/mapbox/dark-v11/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoieXFoZXZ0ZmciLCJhIjoiY205emM3ZGNkMHNxZzJxb2wweDRkM3VwcSJ9.6K3OoUuIs1qvPWmrOZEU2Q",
  // arcgis 图层
  arcgisShow: false, // arcgis图层是否显示
  arcgis1:
    "https://api.cdmbc.cn:4432/gateway/gis/1/5e249977ce1b454eab17999b9122871e?AppKey=962000644045012992", // 锦江区 边界线
  arcgis2:
    "https://api.cdmbc.cn:4432/gateway/gis/1/8780d3715f054a0b948bb3a744d8ba34?AppKey=962000644045012992", // 锦江区 街道边界线
};
const mapBillboard = ref<any>([]);
// 绘制菱形
export function drawBuildMarker(viewer: any, pos: any, name: string) {
  if (!pos) {
    return;
  }
  if (!viewer) {
    return;
  }
  const position = Cesium.Cartesian3.fromDegrees(
    Number(pos[0]),
    Number(pos[1]),
    Number(pos[2] || 0),
  );
  let billboard = viewer.entities.add({
    position: position,
    billboard: {
      color: Cesium.Color.fromCssColorString("#fff").withAlpha(0.8),
      // color: new Cesium.Color(1.0,1.0,1.0,0.8),
      image: pin2d8cf0,
      scale: 2,
      // pixelOffset: this.style.pixelOffset,
      heightReference: 1,
      verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
      // 按距离缩放
      scaleByDistance: new Cesium.NearFarScalar(1.5e2, 2, 20000, 0.0),
      eyeOffset: new Cesium.Cartesian3(0, 0, -90), //Label 被建筑物遮挡问题
    },
    label: {
      // text: '测试',
      text: name,
      // pixelOffset: this.style.pixelOffset, //偏移量
      pixelOffset: new Cesium.Cartesian2(25, -50), //偏移量
      font: "600 16px",
      // horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
      heightReference: 1,
      verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
      fillColor: Cesium.Color.fromCssColorString("#fff"), //字体颜色
      showBackground: true,
      backgroundColor: new Cesium.Color(0.5, 0.6, 1, 1.0), //背景色
      // disableDepthTestDistance: Number.POSITIVE_INFINITY,
      eyeOffset: new Cesium.Cartesian3(0, 0, -100), //Label 被建筑物遮挡问题

      // 按距离缩放
      // scaleByDistance: new Cesium.NearFarScalar(1.5e2, 2, 20000, 0.0),
    },
  });
  mapBillboard.value.push(billboard);
}

// 销毁菱形
export function destoryBuildMarker(viewer: any) {
  // entityCollection.value.show = false;
  if (mapBillboard.value && mapBillboard.value.length > 0) {
    mapBillboard.value.map((item: any) => {
      viewer.entities.remove(item);
    });
    mapBillboard.value = [];
  }
}
// true:数组内的元素存在且不为NaN, false: 数组内的元素存在为空或NaN的情况
export function judgeArrNaN(arr: any) {
  if (Array.isArray(arr)) {
    for (let i = 0; i < arr.length; i++) {
      if (Array.isArray(arr[i])) {
        if (!arr[i] || !judgeArrNaN(arr[i])) {
          return false;
        }
      } else {
        if (!arr[i] || isNaN(arr[i])) {
          return false;
        }
      }
    }
    return true;
  } else {
    if (!arr || isNaN(arr)) {
      return false;
    }
    return true;
  }
}
// 判断数组元素是否有效
export function isValidArray(arr: any) {
  // console.log(183,arr);

  // 辅助函数：递归地处理数组元素
  function processElement(element: any) {
    if (Array.isArray(element)) {
      if (!judgeArrNaN(element)) {
        return [];
      }
      const result = element
        .map(processElement)
        .filter((el) => el != null) as any;
      // 只有处理后的子数组与原子数组长度相等时，才保留该子数组
      // console.log(1922,result);

      return result.length === element.length ? result : null;
    } else if (typeof element === "number") {
      return element;
    } else if (typeof element === "string" && !isNaN(Number(element))) {
      return Number(element);
    } else {
      return null;
    }
  }

  const result = processElement(arr);
  // 只保留最终结果为有效数组的部分
  return Array.isArray(result) ? result : [];
}
// 检查输入类型
export function safeParseFloat(value: any) {
  if (typeof value === "string" || typeof value === "number") {
    // @ts-ignore
    const parsed = parseFloat(value);
    return isNaN(parsed) ? null : parsed; // 返回 null 或其他默认值
  }
  return null; // 如果类型不正确，返回 null 或其他默认值
}
// 隐藏姓名后面所有字符，只显示姓
export function hideName(name: any) {
  if (name) {
    if (name.length < 3) {
      // 获取姓氏
      const lastName = name.substr(0, 1);
      // 替换后面的字符为*
      const hiddenLength = name.length - 1;
      return lastName + "*".repeat(hiddenLength);
    } else {
      const reg = /^1[34578]\d{9}$/;
      if (reg.test(name)) {
        return name.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
      } else {
        let str = name;
        const firstChar = str.charAt(0);
        const lastChar = str.charAt(str.length - 1);
        const middle = str.substring(1, str.length - 1).replace(/./g, "*");
        return firstChar + middle + lastChar;
      }
    }
  } else {
    return "";
  }
}
// 隐藏电话号码中间几位
export function hidePhone(phoneNumber: any) {
  // 判断字符串是否为合法的手机号码，例如 '13800138000'
  const reg = /^1[34578]\d{9}$/;
  if (phoneNumber) {
    if (reg.test(phoneNumber)) {
      return phoneNumber.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
    } else {
      return phoneNumber;
    }
  } else {
    return "";
  }
}
export function calcTableHeight(tableContainer: any, tableElRef: any) {
  // 示例：容器高度减去其他元素占用的空间
  const offset = 100; // 页眉/分页器 头部等高度
  if (!tableContainer) {
    return;
  }

  const tableHeight = tableContainer.clientHeight - offset;
  const height = Math.floor((tableHeight - 30) / 15);
  nextTick(() => {
    const tableEl = tableElRef?.$el;
    let bodyEl = tableEl.querySelector(".ant-table-body");
    bodyEl!.style.height = `${unref(tableHeight - 20)}px`;
    // 创建 <style> 元素
    const style = document.createElement("style");
    style.innerHTML = `
        .row-class {
          height: ${height}px !important;
          max-height: 100px;
          min-height: 38px;
        }
      `;
    // 添加到<head>
    document.head.appendChild(style);
  });
}
// 测试车辆轨迹
export function carlinedata() {
  const point = [
    [104.1087872, 30.6186112],
    [104.1088896, 30.6182976],
  ];
  return point;
}

/**
 * 驼峰转下划线
 * @param str
 */
export function toSnakeCase(str: string): string {
  return str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
}

/**
 * 将对象的键从驼峰命名转换为下划线命名
 * @param obj
 */
export function convertObjectKeysToSnakeCase(obj: any): any {
  if (Array.isArray(obj)) {
    return obj.map((v) => convertObjectKeysToSnakeCase(v));
  } else if (obj !== null && typeof obj === 'object' && obj.constructor === Object) {
    return Object.keys(obj).reduce((result, key) => {
      const snakeKey = toSnakeCase(key);
      (result as any)[snakeKey] = convertObjectKeysToSnakeCase(obj[key]);
      return result;
    }, {} as any);
  }
  return obj;
}

/**
 * px 转 rem 工具函数
 * 基准值：100px = 1rem（与 postcss-pxtorem 配置保持一致）
 * @param px - 像素值
 * @returns rem 字符串，例如 "1.8rem"
 */
export function pxToRem(px: number): string {
  return `${px / 100}rem`;
}

/**
 * px 转换为实际像素值(用于 Cesium 等需要实际像素值的场景)
 * 根据根元素字体大小动态计算,确保响应式布局
 * 基准值：100px = 1rem
 * @param px - 设计稿中的像素值
 * @returns 实际像素值
 * @example
 * // 假设根元素字体大小为 16px
 * pxToPixel(100) // 返回 16 (因为 100px = 1rem = 16px)
 * pxToPixel(50)  // 返回 8  (因为 50px = 0.5rem = 8px)
 */
export function pxToPixel(px: number): number {
  // 获取根元素字体大小
  const rootFontSize = parseFloat(
    getComputedStyle(document.documentElement).fontSize,
  );
  // 基准值：100px = 1rem
  return (px / 100) * rootFontSize;
}

/**
 * 动态计算表格行高度
 * 根据容器高度自动调整表格行高，并动态添加样式
 * @param tableContainer - 表格容器的 ref 元素
 * @param tableElRef - 表格组件的 ref
 * @param options - 可选配置项
 * @param options.paginationSelector - 外置分页区域的选择器，用于动态获取分页高度（如 '.custom-pagination-wrapper'）
 * @param options.hasInternalPagination - 是否使用表格内置分页，默认 false。如果为 true，会自动查找 .ant-table-pagination
 * @param options.offset - 额外偏移量（在分页高度基础上的额外偏移），默认 0
 * @param options.minHeight - 最小行高，默认 33
 * @param options.maxHeight - 最大行高，默认 65
 * @param options.rowClassName - 行样式类名，默认 'row-class'
 */
export function calcDynamicTableHeight(
  tableContainer: any,
  tableElRef: any,
  options?: {
    paginationSelector?: string;
    hasInternalPagination?: boolean;
    offset?: number;
    minHeight?: number;
    maxHeight?: number;
    rowClassName?: string;
  },
) {
  const {
    paginationSelector,
    hasInternalPagination = false,
    offset = 0,
    minHeight = 33,
    maxHeight = 65,
    rowClassName = "row-class",
  } = options || {};

  // 使用 nextTick 确保 DOM 已更新
  nextTick(() => {
    const tableEl = tableElRef.value?.$el;
    if (!tableEl || !tableContainer.value) return;

    const tableHeader = tableEl.querySelector(".ant-table-thead");
    const headerHeight = tableHeader?.offsetHeight || 0;

    // 动态获取分页区域高度
    let paginationHeight = 0;

    // 优先使用外置分页选择器
    if (paginationSelector) {
      const paginationEl =
        tableContainer.value.querySelector(paginationSelector);
      if (paginationEl) {
        paginationHeight = paginationEl.offsetHeight;
      } else {
        paginationHeight = 60;
      }
    }
    // 如果没有外置分页，检查是否使用内置分页
    else if (hasInternalPagination) {
      const internalPaginationEl = tableEl.querySelector(
        ".ant-table-pagination",
      );
      paginationHeight = internalPaginationEl?.offsetHeight || 0;
    }

    const totalOffset = headerHeight + paginationHeight + offset;

    const tableHeight = tableContainer.value.clientHeight - totalOffset;
    let height = Math.floor((tableHeight - 30) / 15);

    const bodyEl = tableEl.querySelector(".ant-table-body");
    if (bodyEl) {
      bodyEl.style.height = `${unref(tableHeight - 0)}px`;
    }

    // 限制行高范围
    if (height < minHeight) {
      height = minHeight;
    }
    if (height > maxHeight) {
      height = maxHeight;
    }

    // 移除旧的样式（避免重复添加）
    const existingStyle = document.getElementById(
      `table-row-style-${rowClassName}`,
    );
    if (existingStyle) {
      existingStyle.remove();
    }

    // 创建 <style> 元素
    const style = document.createElement("style");
    style.id = `table-row-style-${rowClassName}`;
    style.innerHTML = `
      .${rowClassName} {
        height: ${height}px !important;
      }
    `;
    // 添加到<head>
    document.head.appendChild(style);
  });
}
